<template>
    <main-content>
        <gateway-form
                v-if="status == 'successShop'"
                :submit="update"
                :form_data="form_data"
                :port_config="port_config"
        ></gateway-form>
        <switching-setting-user
                v-if="status == 'successShop' && form_data.shop_type == 0"
                :gateway_hashid="hashid"
        ></switching-setting-user>
    </main-content>
</template>

<script>
    import mainContent from '@/components/main-content'
    import $ from "jquery";
    import { i18n } from '@/plugins/i18n'
    import { collectiveService } from '@/common/api.service'
    import { KTApp } from '@/plugins/core/app'
    import { mapGetters } from 'vuex'
    import { gatewayForm } from './components'
    import SwitchingSettingUser from '@/views/gateway/components/SwitchingSettingUser'

    export default {
        components: {
            'main-content': mainContent,
            'gateway-form': gatewayForm,
            'switching-setting-user': SwitchingSettingUser,
        },
        computed: {
            ...mapGetters('collective', ['form_data', 'status']),
        },
        mounted() {
            this.$store.dispatch('collective/findGate', this.hashid)
            // this.port_config = this.form_data.port_config;
        },
        methods: {
            update(){
                let form = $('#gateway_form')
                let btn = $('#submit_btn')

                KTApp.progress(btn)

                let port_config = JSON.stringify(this.port_config)

                this.form_data.port_config = port_config;

                collectiveService.updateGate(this.hashid, this.form_data).then(response => {
                    this.showMsg(form, 'success', i18n.t('message.changes_submitted_successfully'))
                })
                    .catch(({response}) => {
                        if(response.data) {
                            form.validate().showErrors(response.data.data)
                        }
                        this.showMsg(form, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                    })
            },
        },
        data () {
            return {
                hashid: this.$route.params.hashid,
                port_config: {}
            }
        },
    }
</script>

<style>

</style>